import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var regionComponentName = 'QuantumRegion';
export function getRegionUtilityClass(slot) {
    return generateUtilityClass(regionComponentName, slot);
}
export var regionClasses = generateUtilityClasses(regionComponentName, ['root', 'flag', 'label']);
